import { useQuery } from '@tanstack/react-query';
import { postApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Open posts assigned to somebody on one job. */
export function useAssignedPosts(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.posts.assigned(jobId ?? -1),
    queryFn: ({ signal }) =>
      postApiClient.getAssignedPosts(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    meta: { errorContext: 'assigned posts' },
  });
}

/** @registry Open posts assigned to somebody, across every job the user can see. */
export function useAllAssignedPosts() {
  return useQuery({
    queryKey: queryKeys.posts.allAssigned(),
    queryFn: ({ signal }) =>
      postApiClient.getAllAssignedPosts(toCancelToken(signal)),
    meta: { errorContext: 'assigned posts' },
  });
}
